import React from "react";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import { withStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

export default (props) => {  
  const DialogTitle = withStyles(styles)((innerprops) => {
    const { children, classes, onClose, ...other } = innerprops;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={props.handleDialogClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });
  return (
    <Dialog
      onClose={props.handleDialogClose}
      aria-labelledby="customized-dialog-title"
      open={props.open}
    >
      <DialogTitle id="customized-dialog-title" onClose={props.handleDialogClose}>
        {props.title ? props.title : "Pass 'title'"}
      </DialogTitle>
      <DialogContent dividers>{props.children}</DialogContent>
      {/* <DialogActions>
        <Button
          variant="contained"
          //autoFocus
          onClick={props.handleDialogClose}
          color="primary"
        >
          Close
        </Button>
      </DialogActions> */}
    </Dialog>
  );
};
